<div class="search">
    <div class="search-field">
        <wbo-localisation-autocomplete-control>
            <fui-deprecated-autocomplete-control #searchControl [limit]="50" [increment]="50"
                                                 [placeholder]="'wbo.localisation.heading.search'"
                                                 [results]="filteredSearchData"
                                                 [showMore]="'wbo.common.button.showMore'">
                <ng-template #autocompletecontrolresults let-result="result">
                    <div class="search-result">
                        <div class="search-result-action">
                            <div class="search-result-action-media" [ngSwitch]="result.itemType">
                                <fui-icon [height]="14" [icon]="'folder'" *ngSwitchDefault [width]="14"></fui-icon>
                                <fui-icon [height]="14" [icon]="'marker'" *ngSwitchCase="ItemType.OUTLET" [width]="14"></fui-icon>
                            </div>
                            <div class="search-result-action-label">
                                <div class="search-result-action-label-title">
                                    {{result.name}}
                                </div>
                            </div>
                        </div>
                        <div class="search-result-context" [ngSwitch]="isSearchItemSelected(result)" (click)="toggleSelection(result)" *ngIf="!readonly">
                            <fui-context-button *ngSwitchDefault [title]="'wbo.common.button.add'">
                                <fui-icon [height]="8" [icon]="'plus'" [width]="8"></fui-icon>
                            </fui-context-button>
                            <fui-context-button *ngSwitchCase="true" [title]="'wbo.common.button.remove'">
                                <fui-icon [height]="2" [icon]="'remove'" [width]="8"></fui-icon>
                            </fui-context-button>
                        </div>
                    </div>
                </ng-template>
            </fui-deprecated-autocomplete-control>
        </wbo-localisation-autocomplete-control>
    </div>
</div>
